/* unplugin-vue-components disabled */import { render } from "./AnonymousWorkflowSubmit.vue?vue&type=template&id=1ddca520&scoped=true&ts=true"
import script from "./AnonymousWorkflowSubmit.vue?vue&type=script&lang=ts"
export * from "./AnonymousWorkflowSubmit.vue?vue&type=script&lang=ts"

import "./AnonymousWorkflowSubmit.vue?vue&type=style&index=0&id=1ddca520&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddca520"]])

export default __exports__